// @flow

export default function createReducer(actionHandler: *) {
  return (state: *, action: *) => actionHandler(action)(state);
}



// WEBPACK FOOTER //
// ./src/store/createReducer.js